<template>
  <component
    v-bind="$attrs"
    :is="taskModalComponent"
    :action="task"
    :event="event"
    :disabled="event.deletedAt != null"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { TaskTyp, type EventListEventFieldsFragment } from "@/graphql";
import CommonTaskModalComponentVue from "./CommonTaskModalComponent.vue";
import IdeaTaskModalComponentVue from "@/modules/idea/components/eab/IdeaTaskModalComponent.vue";
import ManageTaskModalComponentVue from "@/modules/idea/components/eab/ManageTaskModalComponent.vue";
import CustomTaskModalComponentVue from "./CustomTaskModalComponent.vue";
import type { EditTaskType } from "../helper/DefaultTask";
import type { EventEditType } from "../../event/modal/EventEditType";

const props = defineProps({
  task: {
    type: Object as PropType<EditTaskType>,
    required: true,
  },
  event: {
    type: Object as PropType<EventListEventFieldsFragment | EventEditType>,
    required: true,
  },
});
const taskModalComponent = computed(() => {
  switch (props.task.type) {
    case TaskTyp.common:
    case TaskTyp.AUDIT_TASK:
      return CommonTaskModalComponentVue;
    case TaskTyp.ideaIdea:
      return IdeaTaskModalComponentVue;
    case TaskTyp.ideaManage:
      return ManageTaskModalComponentVue;
    case TaskTyp.CUSTOM:
      return CustomTaskModalComponentVue;

    default:
      throw new Error(`unknown task type: ${props.task.type}`);
  }
});
</script>

<style lang="scss" scoped></style>
